<app-header2></app-header2>
<section class="m-auto mt-lg-5 account-banner ">
    <div class="row  mt-5  ">
        <div class="col-lg-7  px-md-5 col-sm-12 text-center d-none d-lg-block d-md-block"></div>
        <div class="col-lg-4  px-md-5 col-sm-12 text-center "   >
            <p style="color: white;font-weight: 600; font-size: x-large;"><span style="color: #e6922e;">Sign up</span> with <span style="color: #e6922e;">DOKS</span>  in a few minutes</p>
            <div class="registration bg-white">

                <div class="d-flex tab-header">
                    <div id="tab-btn-1" (click)="setTab1()" class="col-6 text-center p-3 tab-btn tab-btn-start selected">Registration</div>
                    <div id="tab-btn-2" (click)="setTab2()" class="col-6 text-center p-3 tab-btn tab-btn-start">Login</div>
                </div>

                <div class="mt-3  pb-5">
                    <div class="py-3" id="login" style="display: none;">
                        <form #f="ngForm" [formGroup]="loginForm" (submit)="login()">
                            <br>
                            <br>
                            <div class="form-group">
                                <div class="col-12  ">
                                    <input type="text" id="name" class="form-control" placeholder="Email" formControlName="email">
                                </div>
                            </div>

                            <div class="form-group text-left">
                                <div class="col-12">
                                    <input  [type]="showPass1.checked ? 'text' : 'password'"  id="msg_subject" class="form-control" placeholder="Password" formControlName="password">
                                </div>
                                <input type="checkbox" #showPass1 (change)="0" class="ml-4" >  Show Password <small class="text-muted"></small>

                            </div>
                            <br>
                            <div lass="form-group ">
                                <div class="text-center w-100">
                                    <button class="btn-orange btn btn-block w-25" [disabled]="!loginForm.valid" #submitBtn>Login</button>
                                </div>
                            </div>
                            <div class="mt-2" >
                                <a href="javascript: void(0);" (click)="return_verification()">Click here to enter Verification Code</a>
                            </div>
                            <div class="mt-2" >
                                <a href="javascript: void(0);" (click)="forget()">Click here to Reset Password</a>
                            </div>

                        </form>
                    </div>
                    <div id="registration" style="display: block;">
                        <form #f="ngForm" [formGroup]="registerForm" (submit)="register()">

                            <div class="form-group">
                                <div class="col-12">
                                    <input type="text" id="fname" class="form-control" placeholder="First Name" formControlName="firstName">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-12">
                                    <input type="text" id="lname" class="form-control" placeholder="Last Name" formControlName="lastName">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-12">
                                    <input type="email" id="email" class="form-control" placeholder="Email" formControlName="email">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-12">
                                    <input type="phone" id="phone" class="form-control" placeholder="Phone" formControlName="phone">
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-12">
                                    <input [type]="showPass.checked ? 'text' : 'password'" id="password" class="form-control" placeholder="Password" formControlName="password">
                                </div>
                            </div>

                            <div class="form-group text-left">
                                <div class="col-12">
                                    <input [type]="showPass.checked ? 'text' : 'password'" id="repassword" class="form-control" placeholder="Re-enter Password" formControlName="repassword">
                                    <input type="checkbox" #showPass (change)="0" class="ml-2" >  Show Password <small class="text-muted"></small>
                                </div>

                            </div>


                            <br>

                            <div class="form-group px-3">
                                <div class="form-row">
                                    <div class="col-auto mx-2">
                                        <input type="checkbox" style="    transform: scale(1.5);" formControlName="terms">
                                    </div>
                                    <p class="col-11  pl-0  text-left text-muted" style="font-size:small;">
                                        By clicking here I give my consent for HAWKto contact me for marketing purposes. You can opt out at any time.
                                    </p>
                                </div>
                            </div>


                            <div lass="form-group ">
                                <div class="text-center w-100">
                                    <button class="btn-orange btn btn-block w-25" [disabled]="!registerForm.valid" #submitBtn>Submit</button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div id="verification" style="display: none;">
                        <form #f="ngForm" [formGroup]="verificationForm" (submit)="verify()">
                            <br>
                            <br>
                            <div class="form-group">
                                <div class="col-12  ">
                                    <input type="text" id="v-mail" class="form-control" placeholder="Email" formControlName="email">
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-12  ">
                                    <input type="text" style="font-weight: 600;" id="v-code" class="form-control" placeholder="Verification Code" formControlName="code">
                                </div>
                            </div>

                            <br>
                            <div lass="form-group ">
                                <div class="text-center w-100">
                                    <button class="btn-orange btn btn-block w-25" [disabled]="!verificationForm.valid" #submitBtn>Verify</button>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div id="forgetPW" style="display: none;">
                        <form #f="ngForm" [formGroup]="forgetPWForm" (submit)="reset()">
                            <br>
                            <br>
                            <div class="form-group">
                                <div class="col-12  ">
                                    <input type="text" id="v-mail" class="form-control" placeholder="Email" formControlName="email">
                                </div>
                            </div>

                            <br>
                            <div lass="form-group ">
                                <div class="text-center w-100">
                                    <button class="btn-orange btn btn-block w-25" [disabled]="!forgetPWForm.valid" #submitBtn>Reset</button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

